import { render } from 'react-dom';
import DataActions from 'flux/actions/DataActions.js';

import Home from 'components/Home.js';
import Contact from 'components/Contact.js';
import Header from 'components/Header.js';
import Default from 'components/Default.js';
import Footer from 'components/Footer.js';
import Guesthouse from 'components/Guesthouse.js';
import Gallery from 'components/Gallery.js';
import About from 'components/About.js';
import ReactGA from 'react-ga';

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';
import DataStore from './flux/stores/DataStore';

class AppInitializer {

  templates = {
    'startsida.php': Home,
    'gasthem.php': Guesthouse,
    'bageri.php': Guesthouse,
    'default': Default,
    'contact.php': Contact,
    'gallery.php': Gallery,
    'about.php': About,
  }

  buildRoutes(data) {
    const routes = []
    Object.keys(data).forEach((lang) => {
      if (lang === 'lang' ||lang === 'languages') return
      
      routes.push(data[lang].pages.map((page, i) => {
        let path = `/${page.slug}`
        if (lang !== 'sv') {
          path = `/${lang}/${page.slug}`

          if (page.template === 'startsida.php') {
            path = `/${lang}`
          }
        }
        return (
          <Route
            key={i}
            component={this.templates[page.template] ? this.templates[page.template] : this.templates['default']}
            path={path}
            exact
          />
        )
      }))
    })
    return routes
  }

  run() {
    ReactGA.initialize('UA-38990802-1');
    ReactGA.event({
      category: 'Entered website',
      action: window.location.pathname + window.location.search
    });
    

    DataActions.getPages((response) => {
      render(
        <Router>
          <div>
            <Header />
            <main className="site">
              <Switch>
                <Route path="/" component={Home} exact />
                {/* Redirects sv */}
                <Route exact path="/gasthem" render={() => <Redirect to="/logi"/>}/>
                <Route exact path="/stugor" render={() => <Redirect to="/logi"/>}/>
                <Route exact path="/gardsbageri" render={() => <Redirect to="/bageri-cafe"/>}/>
                <Route exact path="/aktuell" render={() => <Redirect to="/om-oss"/>}/>
                <Route exact path="/gasthem/green-key" render={() => <Redirect to="/om-oss"/>}/>

                {/* Redirects fi */}
                <Route exact path="/vieraskoti" render={() => <Redirect to="/fi/vieraskoti"/>}/>
                <Route exact path="/vierasmokit" render={() => <Redirect to="/fi/vieraskoti"/>}/>
                <Route exact path="/leipomo" render={() => <Redirect to="/fi/leipomo"/>}/>
                <Route exact path="/ajankohtaista" render={() => <Redirect to="/fi/meista"/>}/>
                <Route exact path="/yhteys" render={() => <Redirect to="/fi/yhteys"/>}/>
                <Route exact path="/vieraskoti/green-key/" render={() => <Redirect to="/fi/meista"/>}/>

                {/* Redirects en */}
                <Route exact path="/guesthouse" render={() => <Redirect to="/en/bb"/>}/>
                <Route exact path="/cabins" render={() => <Redirect to="/en/bb"/>}/>
                <Route exact path="/bakery" render={() => <Redirect to="/en/bakery"/>}/>
                <Route exact path="/news" render={() => <Redirect to="/en/about-us"/>}/>
                <Route exact path="/contact" render={() => <Redirect to="/en/contact"/>}/>
                <Route exact path="/guesthouse/green-key/" render={() => <Redirect to="/en/about-us"/>}/>

                {this.buildRoutes(response)}
                <Route render={() => { return <Redirect to="/" /> }} />
              </Switch>
            </main>
            <Footer />
          </div>
        </Router>

        , document.getElementById('app')
      );
    });
  }
}

new AppInitializer().run();



// WEBPACK FOOTER //
// ./src/scripts/index.js